(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46642],{

/***/ 12769:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topbusinessquotes",
      function () {
        return __webpack_require__(56812);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ TopBusinessQuotesHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layouts_topBusinessQuotesWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21260);
/* harmony import */ var _components_topbusinessquotes_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34404);
/* harmony import */ var _components_topbusinessquotes_whyTopBusinessQuotes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3441);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





var __N_SSP = true;
function TopBusinessQuotesHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_topBusinessQuotesWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topbusinessquotes_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_topbusinessquotes_whyTopBusinessQuotes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,57079,10761,30425,32259,49774,92888,40179], function() { return __webpack_exec__(12769); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);